import { styled } from '@mui/material/styles';
import TableRow from '@mui/material/TableRow';
import Colors from '../../../theme/colors';

const HeaderTableRow = styled(TableRow)({
  backgroundColor: Colors.Main.Background,
});

export default HeaderTableRow;
